import InputRadio from './InputRadio'

export default InputRadio
